import styled from "styled-components"


export const Container = styled.div`
    margin-top: 130px;
    display: block;
    width: 100%;
    padding: 20px 0px;
    font-size: 13px;
    color: #969696;
    text-align: center;

    &:hover{
        color: #BB86FC;
    }
`;

export const Text = styled.p`

`;
